<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        العقود
        <v-spacer></v-spacer>

        <v-text-field rounded v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        <div style="width: 20px"></div>
        <AddContract @reloadTask="initialData()" :resources="resources" :currencies="currencies" />
      </v-card-title>
      <v-data-table :headers="headers" :items="ItemsFilter" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <template v-slot:[`item.remain`]="{ item }">
          <h4 style="padding: 0 3px">
            {{
              (item.contractAmount - item.getPaid).toLocaleString("en-US", {
                style: "currency",
                currency: "IQD",
              })
            }}
          </h4>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon @click="dialog = false">
            <DeleteContract :dataToDelete="item" @reloadTask="initialData()" v-if="$store.state.userData.roleId == 1" />
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import AddContract from "./contract/AddContract.vue";
import DeleteContract from "./contract/DeleteContract.vue";
export default {
  components: {
    AddContract,
    DeleteContract,
  },
  data: () => ({
    overlay: false,
    search: "",
    contracts: [],
    headers: [
      { text: "التسلسل", value: "index" },
      { text: "المبلغ", value: "contractAmount" },
      { text: "المقبوض", value: "getPaid" },
      { text: "المتبقي", value: "remain" },
      { text: "التاريخ", value: "contractDateFormat" },
      { text: "التفاصيل", value: "contractNote" },
      { text: "مصدر الايراد", value: "resourceName" },
      { text: "نوع العملة", value: "currencyName" },
      { text: "الاجراءات", value: "actions" },
    ],
    currencies: [],
    resources: [],
    types: [],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.overlay = true;

      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrl}/generationContracts`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrl}/currencies`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrl}/generationResources`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((contracts, currencies, resources) => {
            self.contracts = contracts.data;
            self.currencies = currencies.data;
            self.resources = resources.data;

            self.overlay = false;
          })
        )
        .catch((error) => {
          self.overlay = false;
          console.log(error);
        });
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.contracts.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.resourceName.toLowerCase().includes(v));
        });
      } else {
        return this.contracts;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
